<template>
  <img :src="require(`@/${src}`)" class="parralax-img" alt="" ref="img">
</template>

<script>
import simpleParallax from 'simple-parallax-js';
import store from '@/store/store';

export default {
  name: 'ParralaxImg',
  props: {
    src: {
      type: String,
      required: true
    },
    scale: {
      type: Number,
      required: false,
      default: 1.4
    },
    orientation: {
      type: String,
      required: false,
      default: 'up'
    },
  },
  mounted () {
    this.simpleParallex = new simpleParallax(this.$refs.img, {
      scale: this.scale,
      orientation: this.orientation,
      overflow: true
    });

    this.bind()
  },
  methods: {
    bind () {
      store.resize.listen(this.resize)
    },
    unbind () {
      store.resize.unlisten(this.resize)
    },
    resize () {
      this.simpleParallex.refresh()
    }
  },
  beforeUnmount () {
    this.unbind()
  }
}
</script>

<style lang="scss" scoped>
   .parralax-img {
      width: 100%;
      object-fit: contain;
    }
</style>
